<template>
	<div>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
		<dl class="opport-screen bdbe" style="padding-top: 10px;">
		<dt class="fl" style="margin-top: 24px;">{{ dlname }}时间</dt>
		<dd class="fl">
			<div class="clue_finantime" v-show="timetype != 3">
				<h3 :style="'padding-left:' + titlesize + 'px;'">2024年</h3>
				<span :key="i" v-for="(item, i) in financingTime" @click="chooseFun(item, i)"
					:class="{ 'a-screen': true, 'current': finantime == item.time, 'borderrightt': i == borderindex }">{{ item.text }}</span>
			</div>
			<div class="clue_finantime" v-show="timetype == 3">
				<h3 style="padding-left:40px;">2023年</h3>
				<span :key="i" v-for="(item, i) in financingTime" @click="chooseFun(item, i)"
					:class="{ 'a-screen': true, 'current': finantime == item.time, 'borderrightt': i == 0 }">{{ item.text }}</span>
			</div>
			<el-tooltip class="item smartTip-text listeltootipicon" effect="light" placement="top-start"
				v-show="showTips">
				<i class="el-icon-question"></i>
				<div slot="content" class="list_tips">
					{{ dlname }}时间：最近一年获得{{ dlname }}的企业
				</div>
			</el-tooltip>
		</dd>
	</dl>
	</div>
	
</template>
<script>
import { getMonthLength } from '@/utils/common.js'
export default {
	name: 'zpagenav',
	data() {
		return {
			userdata: {},//每个月都要修改  updatetime
			isShowFreeUserTips: false,
			finantime: "year",
			finantime2: "",
			financingTime: [],
			financingTime1: [//手动添加时间 每月1号后新增新的月份{time:"2021-07",text:'7月'},{time:"2021-09",text:'9月'},
				{ time: "year", text: '全部' },
				{ time: "2023-12", text: '12月' }, 
				{ time: "2024-01", text: '1月' },
				{ time: "2024-02", text: '2月' }, 
				{ time: "2024-03", text: '3月' }, 
				{ time: "2024-04", text: '4月' }, 
				{ time: "2024-05", text: '5月' }, 
				{ time: "2024-06", text: '6月' }, 
				{ time: "2024-07", text: '7月' },
				{ time: "2024-08", text: '8月' }, 
				{ time: "2024-09", text: '9月' }, 
				{ time: "2024-10", text: '10月' },
				{ time: "2024-11", text: '11月' },  
			],
			financingTime2: [//手动添加时间 每月十五号后新增新的月份{time:"2021-07",text:'7月'},{time:"2021-09",text:'9月'},
				{ time: "year", text: '全部' },
				{ time: "2023-12", text: '12月'},
				{ time: "2024-01", text: '1月' },
				{ time: "2024-02", text: '2月' },
				{ time: "2024-03", text: '3月' },
				{ time: "2024-04", text: '4月' }, 
				{ time: "2024-05", text: '5月' }, 
				{ time: "2024-06", text: '6月' }, 
				{ time: "2024-07", text: '7月' }, 
				{ time: "2024-08", text: '8月' }, 
				{ time: "2024-09", text: '9月' }, 
				{ time: "2024-10", text: '10月' },
				{ time: "2024-11", text: '11月'},
			],
			financingTime3: [ //固定的，暂时不需要定时更新
				{ time: "year", text: '全部' },
				{ time: "1", text: '1月' },
				{ time: "2", text: '2月' },
				{ time: "3", text: '3月' },
				{ time: "4", text: '4月' }, 
				{ time: "5", text: '5月' }, 
				{ time: "6", text: '6月' }, 
				{ time: "7", text: '7月' }, 
				{ time: "8", text: '8月' }, 
				{ time: "9", text: '9月' }, 
				{ time: "10", text: '10月' }, 
				{ time: "11", text: '11月' }, 
				{ time: "12", text: '12月' },
			],
			titlesize: 0,//标题的向左位移值
			borderindex: 0,//标题的边框索引值
			isShowFreeUserTips:false,
		}
	},
	props: {
		dlname: { type: String, default: "融资" },
		type: { type: String, default: "month" },//默认为月份 比如2023-03 有些需要日期 比如2023-03-01
		timetype: { type: Number, default: 1 },//更新时间不一样
		showTips: { type: Boolean, default: true },//是否显示小问号提示
		isChoose: { type: Boolean, default: true }, //是否可选
	},
	computed: {

	},
	created() {
		this.userdata = this.getuseriformation();
		// console.log('调用时间',this.timetype)
		if (this.timetype == 1) {
			this.financingTime = this.financingTime1;
			this.titlesize = 365; this.borderindex = 5;
		} else if (this.timetype == 2) {
			this.financingTime = this.financingTime2;
			this.titlesize = 365; this.borderindex = 5;
		} else if (this.timetype == 3) {
			this.financingTime = this.financingTime3;
		}
	},
	methods: {
		chooseFun: function (item, i) {
			if(!this.isChoose){
				this.isShowFreeUserTips =true;
				return;
			}
			if (this.finantime == item.time) {
				return;
			} else {
				this.finantime = item.time;
				this.$emit('chooseFinancing', this.finantime);
			}
			// if(this.finantime!=item.time) { 
			// 	this.finantime=item.time; 
			// 	var len=this.financingTime.length-1;
			// 	if(this.finantime!= 'all' & i != len){
			// 		this.finantime2=this.financingTime[i+1].time;
			// 	}else if(this.finantime == ''){
			// 		this.finantime2=this.financingTime[len].time;
			// 	}else if(i == len){
			// 			this.finantime2="";
			// 	}  
			// 	// this.$emit('chooseFinancing', this.finantime,this.finantime2);

			// }
		},
		getFinancingTime(item, i) { //作废
			if (this.finantime == item.time) {
				return;
			} else {
				this.finantime = item.time;
				var timeObj = { date1: '2023-03', date2: '2024-02' };
				if (item.time == 'all') {
					timeObj = { date1: '2023-03', date2: '2024-02' };
				} else {
					timeObj = { date1: item.time, date2: item.time };
				}
				if (this.type == 'day') {
					timeObj.date1 = item.time + '-01';
					timeObj.date2 = item.time + '-' + getMonthLength(item.time);
				}
				console.log(timeObj);
				// this.$emit('chooseFinancing', timeObj.date1,timeObj.date2);


			}
		},


	},

}



</script>

<style>
.jump {
	display: inline-block;
	margin-left: 20px;
	font-size: 14px;
}

.jumppage {
	border: 1px solid #EEEEEE;
	width: 50px;
	height: 30px;
	margin: 0px 10px;
	border-radius: 4px;
	text-align: center;
}

.jumppage_btn {
	cursor: pointer;
	display: inline-block;
	width: 70px;
	height: 30px;
	background-color: #3e7bfa;
	border-radius: 4px;
	color: #ffffff;
	line-height: 30px;
	margin-left: 10px;
}
</style>
